export default "__VITE_ASSET__AHD7xYzw__"